export default "__VITE_ASSET__BjtJL2ve__"